<template>
  <div class="winners-2019-qualification-winner">
    <QualificationPrize2020
      class="winners-2019-qualification-winner__prize"
      :prize="prize"
    />
    <div class="winners-2019-qualification-winner__label">Приз получил</div>
    <UserBadge class="winners-2019-qualification-winner__user" :user="user" />
  </div>
</template>

<script>
import UserBadge from "@/components/user/UserBadge";
import QualificationPrize2020 from "@/components/prizes/prizes2020/QualificationPrize2020";

export default {
  name: "Winners2019QualificationWinner",
  props: {
    prize: {
      type: Object,
      required: true
    },
    user: {
      type: Object
    }
  },
  components: {
    UserBadge,
    QualificationPrize2020
  }
};
</script>

<style lang="scss">
.winners-2019-qualification-winner {
  width: 200px;
  &__prize {
    font-size: 14px;
  }
  &__label {
    background: rgba(#000a25, 0.7);
    border-radius: 4px;
    line-height: 40px;
    height: 40px;
    margin-bottom: 10px;
    margin-top: 23px;
    font-weight: 700;
  }
}
</style>
